
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';

import { APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { APP_ROUTES } from './app.routes';
import { BreadcrumbService } from './breadcrumb.service';
import { LoginComponent } from './login/login.component';
import { PaginasModule } from './paginas/paginas.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UsuarioSessionService } from './paginas/servicios/usuario-session.service';
import { DatosSesionService } from './paginas/servicios/datos-sesion.service';
import { MessageService } from 'primeng/primeng';



@NgModule({
    imports: [
        PaginasModule
        , APP_ROUTES
        , BrowserModule
        , BrowserAnimationsModule
    ],
    declarations: [
        AppMainComponent
        , LoginComponent
    ],
    providers: [        
        UsuarioSessionService,
        DatosSesionService,
        MessageService,
    
        {
            provide: APP_INITIALIZER,
            useFactory: IniciarInformacionUsuario,
            deps: [UsuarioSessionService],
            multi: true
        },
        {
            provide: LocationStrategy, useClass: HashLocationStrategy
        }
       
        , BreadcrumbService
    ],
    bootstrap: [AppMainComponent]
})
export class AppModule { }

export function IniciarInformacionUsuario(_usuarioSessionService: UsuarioSessionService) {
    console.log('Inicia con el cargo informacion usuario');
    
    return () => _usuarioSessionService.cargaInformacionLogeo();
}